"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var client_1 = require("@apollo/client");
var react_1 = require("@emotion/react");
var faRepeat_1 = require("@fortawesome/free-solid-svg-icons/faRepeat");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var use_pusher_1 = require("@harelpls/use-pusher");
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var Menu_1 = require("../Menu");
var RematchQueries_1 = require("../Rematch/RematchQueries");
var RematchDisplay_1 = __importDefault(require("./RematchDisplay"));
function RematchSection(_a) {
    var _b;
    var openDialog = _a.openDialog;
    var t = (0, react_i18next_1.useTranslation)().t;
    var query = new URLSearchParams(window.location.search);
    var gameId = query.get('game');
    var canRematchResult = (0, client_1.useQuery)(RematchQueries_1.CAN_REMATCH, { variables: { id: gameId } });
    var game = (_b = canRematchResult.data) === null || _b === void 0 ? void 0 : _b.game;
    var rematch = (0, client_1.useMutation)(RematchQueries_1.REMATCH)[0];
    var channel = (0, use_pusher_1.useChannel)('rematch=' + gameId);
    (0, use_pusher_1.useEvent)(channel, 'rematch', function () { return canRematchResult.refetch(); });
    (0, use_pusher_1.useEvent)(channel, 'pusher:subscription_succeeded', function () { return canRematchResult.refetch(); });
    (0, react_2.useEffect)(function () {
        if (game === null || game === void 0 ? void 0 : game.rematch)
            openDialog();
    }, [game === null || game === void 0 ? void 0 : game.rematch]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(game === null || game === void 0 ? void 0 : game.canRematch) &&
                (0, jsx_runtime_1.jsxs)("button", __assign({ css: [Menu_1.menuButtonCss, (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["display: inline-block"], ["display: inline-block"])))], onClick: function () { return rematch({ variables: { gameId: gameId } }).catch(function () { return canRematchResult.refetch(); }); } }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faRepeat_1.faRepeat }), t('rematch.button')] })), (game === null || game === void 0 ? void 0 : game.rematch) && (0, jsx_runtime_1.jsx)(RematchDisplay_1.default, { rematch: game.rematch })] }));
}
exports.default = RematchSection;
var templateObject_1;
//# sourceMappingURL=RematchSection.js.map